import React, { useEffect, useState } from "react";
import { Layout, Space, Table, PageHeader, Select, Button, message, Avatar, Row, Col, Tabs, Divider } from "antd";
import { useHistory, useRouteMatch, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import "./style.scss"



const DraggableTable = ({text}) => {

    const history = useHistory();
    const [section, setSections] = useState([])
    const adminRestaurant = useSelector((state) => state.admin)






    // useEffect(() => {
    //     setSections(sectionItems)

    // }, [sectionItems])

   const handleDrag = (event)=>{
       
        event.dataTransfer.setData('text/plain',JSON.stringify(text) );
       

    }

    const borderStyle={
        border: `1px solid ${text.color?text.color:"red"}`
    }

    return (
        <div className="draggable-floor-item"  > 
            <span style={borderStyle} className="draggable-table-num" >Top {text?.occupancy}</span>
            <span className="number-table">x {text?.number_of_table}</span>
        </div>
        
    );
};

export default DraggableTable;
